import Vue from 'vue';
import VueRouter from 'vue-router';
import firebase from 'firebase/app';
import 'firebase/auth';

import routes from './routes';
import store from '../store';

Vue.use(VueRouter);

export const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  }

  const position = {};

  if (to.hash) {
    position.selector = to.hash;
  } else {
    position.x = 0;
    position.y = 0;
  }

  return position;
};

const router = new VueRouter({
  mode: 'history',
  scrollBehavior,
  routes,
});

const processRoute = (to, from, next, user) => {
  const requiresAuth = !to.meta.noAuth;
  const { allowAuth } = to.meta;
  const goingToAuth = to.name === 'signup' || to.name === 'login';
  const isLoggedIn = Boolean(user);
  const { attemptedRoute } = store.state.auth;
  const handleLogin = to.path === '/handleLogin';
  const homePage = to.path === '/home';

  store.commit('SET_FULL_SCREEN', Boolean(to.meta.fullScreen));

  if (homePage && isLoggedIn) {
    next('/dashboard');
  } else if (homePage && !isLoggedIn) {
    next('/signup');
  } else if (!isLoggedIn && goingToAuth) {
    next();
  } else if (requiresAuth && !isLoggedIn) {
    store.commit('auth/SET_ATTEMPTED_ROUTE', to);
    next('/signup');
  } else if (!requiresAuth && isLoggedIn && !allowAuth) {
    next('/dashboard');
  } else if (handleLogin) {
    if (attemptedRoute) {
      store.commit('auth/SET_ATTEMPTED_ROUTE', null);
      next({ path: attemptedRoute.path, query: attemptedRoute.query });
    } else {
      next('/dashboard');
    }
  } else {
    next();
  }
};

router.beforeEach((to, from, next) => {
  const { currentUser } = firebase.auth();

  if (currentUser) {
    store.dispatch('auth/LOGIN', currentUser)
      .then((user) => {
        processRoute(to, from, next, user);
      });
  } else {
    store.commit('auth/LOGOUT');
    processRoute(to, from, next, null);
  }
});

export default router;
